/**
 * Results feature hooks — React Query wrappers for scoring.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { resultsApi } from './api'

// ── Scoring / Results ────────────────────────────────────────────────────────

export function useResults(assessmentId: string) {
    return useQuery({
        queryKey: ['results', assessmentId],
        queryFn: async () => {
            const res = await resultsApi.get(assessmentId)
            return res.data
        },
        enabled: !!assessmentId,
    })
}

export function useRecalculateScores(assessmentId: string) {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: () => resultsApi.recalculate(assessmentId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['results', assessmentId] })
        },
    })
}
